import { createTheme } from '@mui/material/styles';
import { BaseMuiThemeComponentsSettings } from './toolympus/components/primitives/BaseThemeSettings';

export const ThemeSettings = {
  colors: {
    primary: "#008cca",
    primaryL1: "#008cca", 
    secondary: "#bad1ec",
    background: "#fdfdff",
    background_panel: "#f0f0f8",
    dark: "#18222e",
    blue_grey: "#869ab7",
    blue_grey_light: "#b9d1ef",
    blue_grey_dark: "#4e5b74",
    text: "#10100e",
    textSecondary: "#10100ea0",
    black: "#10100e",
    
    border_light: "#d0d0ce",
    // border_light: "#10100e",

    danger: "#fc5315",
    warning: "#fcc715",
    success: "#3aa98b",
  },

  fontSize: {
    small: "0.8rem",
  },
}


export const theme = createTheme({
    palette: {
        primary: {
            main: ThemeSettings.colors.primary,
        },
        secondary: {
            main: ThemeSettings.colors.secondary,
        },
        text: {
          primary: ThemeSettings.colors.dark,
          secondary: ThemeSettings.colors.blue_grey_dark,
        },
    },

    typography: {
      h4: {
        fontSize: "1.6rem",
      }
    },

    components: {
      ...BaseMuiThemeComponentsSettings,
      MuiFormLabel: {
        styleOverrides: {
          root: {
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          shrink: {
            transform: "translate(0, -1.5px) scale(0.5625)",
            textTransform: "uppercase",
          },
          root: {
          },
        },
      },

      
      MuiButton: {
        ...(BaseMuiThemeComponentsSettings?.MuiButton || {}),
        styleOverrides: {
          root: ({ ownerState, theme }) => ({
            // Если цвет не задан (или задан как inherit)
            ...(ownerState.color === 'inherit' && {
              color: theme.palette.action.active,
              
              // '&:hover': {
              //   backgroundColor: 'rgba(158, 158, 158, 0.08)',
              // }
            }),
          }),
        },
      },
    },
});
